import { setConfirmJoinOrganizationModal } from '../../../../../store/workspace/slice';
import { updateInvitedMemberInfoThunk } from '../../../../../store/workspace/thunks';
import { InviteMemberIcon, JoinOrganizationIcon } from '../../../../../assets/icons';
import { selectInviteMemberToken } from '../../../../../store/workspace/selectors';
import { setSignUpMode, setSignUpStep } from '../../../../../store/signUp/slice';
import { setAccessToProtectedRoutes } from '../../../../../store/auth/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import { selectEmail } from '../../../../../store/signUp/selectors';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';

interface InvitedUserInfo {
    companyName: string;
    firstName: string;
    lastName: string;
    role: string;
};

export default function ConfirmJoinOrganization() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userEmail = useSelector(selectEmail);
    const [isLoading, setIsLoading] = useState(false);
    const token = useSelector(selectInviteMemberToken);
    const [userInfo, setUserInfo] = useState<InvitedUserInfo | null>(null);

    /** Reading the invitation tells us whether the profile is complete yet. */
    useEffect(() => {
        dispatch(updateInvitedMemberInfoThunk({ token, email: userEmail }))
            .unwrap()
            .then(setUserInfo)
            .catch(() => {
                setIsLoading(false);
            });
    }, []);

    const closeModal = () => dispatch(setConfirmJoinOrganizationModal(false));

    const confirm = () => {
        /** An incomplete invitation has to finish signing up before joining. */
        if (!userInfo?.firstName || !userInfo.lastName || !userInfo.role) {
            dispatch(setAccessToProtectedRoutes(true));
            dispatch(setSignUpMode('Member'));
            dispatch(setSignUpStep('memberInfo'));
            closeModal();
            navigate('/signup');
            return;
        }

        setIsLoading(true);
        dispatch(updateInvitedMemberInfoThunk({
            token,
            email: userEmail,
            role: userInfo.role,
            lastName: userInfo.lastName,
            firstName: userInfo.firstName,
        }))
            .unwrap()
            .then(() => {
                window.location.reload();
            })
            .catch(() => {
                setIsLoading(false);
            });
    };

    return (
        <Modal
            size='sm'
            actions='both'
            closeFunc={closeModal}
            title='Become a member'
            icon={<InviteMemberIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Primary',
                disabled: isLoading,
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Confirm',
                type: 'Primary',
                loading: isLoading,
                onClick: confirm,
            }}
        >
            <JoinOrganizationIcon />
            <p>
                Are you accepting the invitation from <b>{userInfo?.companyName}</b> to
                become a member of this organization account?
            </p>
        </Modal>
    );
};
